import { render, staticRenderFns } from "./invite-members.vue?vue&type=template&id=4f55d066&scoped=true"
import script from "./invite-members.vue?vue&type=script&lang=js"
export * from "./invite-members.vue?vue&type=script&lang=js"
import style0 from "./invite-members.vue?vue&type=style&index=0&id=4f55d066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55d066",
  null
  
)

export default component.exports